import { useState, useContext } from "react";
import { AuthContext } from "../Context/AuthContext";
import { useNavigate } from "react-router-dom";
import { useToast } from "../Context/ToastContext";

const useFormValidationLogin = () => {
  const { login, userType } = useContext(AuthContext);
  const { showToast } = useToast(); 
  const navigate = useNavigate();

  const defaultFormData = {
    email: "",
    password: "",
  };

  const [formData, setFormData] = useState(defaultFormData);
  const [errors, setErrors] = useState({});
  const [resDataError, setResDataError] = useState(null); 
  const [show, setShow] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  
  const setSessionStorageWithExpiry = (key, value, expiryTime) => {
    const data = {
      value,
      expiry: new Date().getTime() + expiryTime,
    };
    sessionStorage.setItem(key, JSON.stringify(data));
  };


  // Store email and password in session storage
  const expiryTime = 300000; // 5 minutes
  setSessionStorageWithExpiry("userEmail", formData.email, expiryTime);
  setSessionStorageWithExpiry("userPassword", formData.password, expiryTime);

  const validateEmail = (email) => {
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    return emailRegex.test(email);
  };

  const validatePassword = (password) => {
    const errors = [];

    if (!password) {
      errors.push("Password is required");
    } else if (password.length < 6) {
      errors.push("Password must be at least 6 characters long");
    }

    return errors.length === 0 ? null : errors;
  };

  const handleInputChange = (e) => {
    setErrors({});
    setResDataError(null);
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleShow = () => {
    setShow(!show);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {};

    if (!validateEmail(formData.email)) {
      newErrors.email = "Invalid email address";
    }

    const passwordErrors = validatePassword(formData.password);
    if (passwordErrors) {
      newErrors.password = passwordErrors;
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      setIsLoading(true);

      try {
        let endpoint = "";
        if (userType === "Charterer") {
          endpoint = `${process.env.REACT_APP_SERVER_URL}/auth/login/charterer`;
        } else if (userType === "Vessel Owner") {
          endpoint = `${process.env.REACT_APP_SERVER_URL}/auth/login/vesselOwner`;
        }

        const res = await fetch(endpoint, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        });

        const resData = await res.json();

        if (!res.ok) {
          if (resData.message === "Please Verify Your Email Address") {
            setResDataError(resData.message);
            setTimeout(() => {
              navigate("/AccountVerification");
            }, 2000);
            return;
          } else if (
            resData.message === "Double Email OTP Verifiication Needed"
          ) {
            setResDataError(resData.message);
            setTimeout(() => {
              navigate("/double_check");
            }, 2000);
            return;
          } else {
            throw new Error(resData.message);
          }
        }

        const profileData = {
          email: formData.email,
          role: resData.data.user.role,
          userId: resData.data.user._id,
          token: resData.token,
        };

        login(profileData);
        showToast("You have logged in successfully!", "success");
       
        if (resData.data.user.role === "charterer") {
          const profileStepStatus =
            resData.data.user.createdProfileStepStatus?.status;

          if (profileStepStatus === "1") {
            navigate("/statutorydocs");
          } else if (profileStepStatus === "2") {
            navigate("/license");
          } else if (profileStepStatus === "3") {
            navigate("/otherdocs");
          } else if (
            profileStepStatus === undefined ||
            profileStepStatus === null
          ) {
            navigate("/Customeractivationpage1");
          } else {
            navigate("/charterer-dashboard");
          }
        } else if (resData.data.user.role === "vesselOwner") {
          const profileStepStatus =
            resData.data.user.createdProfileStepStatus?.status;
          if (profileStepStatus === "1") {
            navigate("/statutory_v_doc");
          } else if (profileStepStatus === "2") {
            navigate("/licenses_v");
          } else if (profileStepStatus === "3") {
            navigate("/otherdocs_v");
          } else if (
            profileStepStatus === undefined ||
            profileStepStatus === null
          ) {
            navigate("/createprofile_step_1");
          } else {
            navigate("/dashboard");
          }
        } else {
          navigate("/");
        }
      } catch (error) {
        // showToast("Login failed!", "error");
        setResDataError(error.message);
      } finally {
        setIsLoading(false);
      }
    }
  };




  
  return {
    formData,
    errors,
    resDataError,
    isLoading,
    handleInputChange,
    handleSubmit,
    handleShow,
    show,
  };
};

export default useFormValidationLogin;
